var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherincome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_934_12910",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.000148773H50.4999V50H0.5V0.000148773Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7499 49.25V0.750149H1.25V49.25H49.7499Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_934_12910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2568 28.0811H3.37402C2.1914 28.0811 1.23242 29.0391 1.23242 30.2217V32.917C1.23242 34.1006 2.1914 35.0586 3.37402 35.0586H22.3212",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7744 21.1025H30.5078C31.2627 21.1025 31.9257 21.4932 32.3066 22.082",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3642 28.0801H19.7744",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2568 28.0801H7.34277C6.16015 28.0801 5.20117 27.1211 5.20117 25.9385V23.2432C5.20117 22.0606 6.16015 21.1016 7.34277 21.1016H11.2568",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1777 14.1231H27.7168C28.8994 14.1231 29.8584 15.082 29.8584 16.2647V18.96C29.8584 20.1426 28.8994 21.1016 27.7168 21.1016H19.7744",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85253 14.1231H4.55175C3.36914 14.1231 2.41016 15.082 2.41016 16.2647V18.96C2.41016 20.1426 3.36914 21.1016 4.55175 21.1016H11.2568",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3212 35.0586H5.32714C4.14453 35.0586 3.18555 36.0176 3.18555 37.2002V39.8955C3.18555 41.0781 4.14453 42.0371 5.32714 42.0371H24.0888",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1493 47.1611C29.0097 48.208 28.1122 49.0156 27.0273 49.0156H3.8623C2.67968 49.0156 1.7207 48.0566 1.7207 46.874V44.1787C1.7207 42.9961 2.67968 42.0371 3.8623 42.0371H24.0888",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0351 25.8829C48.3495 28.3399 49.7675 31.6504 49.7675 35.2911C49.7675 42.8711 43.623 49.0156 36.0429 49.0156C28.4638 49.0156 22.3193 42.8711 22.3193 35.2911C22.3193 27.712 28.4638 21.5675 36.0429 21.5675C38.9286 21.5675 41.6063 22.4581 43.8162 23.9805",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4301 30.9353C38.4301 30.9353 37.0721 29.9036 34.9786 30.423C33.0566 30.8998 32.5792 33.0658 33.8853 33.9096C34.6354 34.3941 35.7639 34.7924 37.2848 35.2352C40.6888 36.2261 39.4304 40.1798 35.9679 40.1987C34.6166 40.2062 33.9849 40.1355 32.7979 39.496",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9678 28.941V41.6406",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3108 35.2913C45.3108 40.4095 41.1618 44.5586 36.0436 44.5586C30.9254 44.5586 26.7764 40.4095 26.7764 35.2913C26.7764 30.1732 30.9254 26.0241 36.0436 26.0241C41.1618 26.0241 45.3108 30.1732 45.3108 35.2913Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27707 18.7969C8.59933 18.9141 8.95089 18.9786 9.32491 18.9786H11.2565V30.2764C11.2565 31.335 12.1149 32.1934 13.1735 32.1934H17.8571C18.9157 32.1934 19.7741 31.335 19.7741 30.2764V18.9786H21.7048C24.0495 18.9786 25.5153 16.4395 24.3424 14.4092L18.153 3.68954C16.9802 1.65927 14.0495 1.65829 12.8776 3.68856L6.68723 14.4092C6.27805 15.1182 6.19016 15.8887 6.34836 16.5909",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9573 16.1033L36.9014 15.8942C36.7037 15.1569 37.1108 14.3926 37.833 14.145L40.054 13.3835C40.8495 13.1107 41.7096 13.5688 41.9274 14.3811L42.0665 14.9007C42.2843 15.713 41.7683 16.5398 40.9429 16.7013L38.6388 17.1524C37.8896 17.2991 37.1549 16.8406 36.9573 16.1033Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4093 9.84425L33.2563 9.69122C32.7166 9.15148 32.687 8.28595 33.1884 7.71047L34.7312 5.94055C35.2837 5.30657 36.2578 5.27317 36.8525 5.8678L37.2327 6.24817C37.8274 6.84279 37.794 7.81681 37.16 8.36935L35.39 9.91212C34.8147 10.4137 33.9491 10.384 33.4093 9.84425Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2073 6.20025L26.9982 6.14429C26.261 5.94664 25.8025 5.21197 25.9491 4.46285L26.4002 2.15866C26.5618 1.33327 27.3886 0.817355 28.201 1.03503L28.7204 1.17429C29.5327 1.39186 29.9908 2.25212 29.7181 3.04762L28.9566 5.26861C28.7091 5.99068 27.9447 6.39781 27.2073 6.20025Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherincome);
export default __webpack_public_path__ + "static/media/otherincome.b5feb0c4cb7c1bbfbc28bd1200ecd65b.svg";
export { ForwardRef as ReactComponent };